import { API } from '@hero/api';
import {
  Currency,
  objectIdSchema,
  paginationSchema,
  Wallet,
  WalletSchema,
  walletStatusSchema,
  WalletHolderTypeSchema,
} from '@hero/schema';
import { z } from 'zod';

export const WalletCreateAPISchema = z.object({
  /** the _id of the holder such as User Id, Business Id, Carrier Id, Driver Id, etc */
  holderId: objectIdSchema,
  /** the type of the holder */
  type: WalletSchema.model.shape.holder.shape.type,
});

export type WalletCreateAPI = API<z.infer<typeof WalletCreateAPISchema>, Wallet>;

export type WalletCurrentUserBalanceAPI = API<undefined, Wallet>;

// Admin APIs
export const walletGetOneAdminAPISchema = z.object({
  /** the wallet id */
  _id: objectIdSchema,
});
export type WalletGetOneAdminAPI = API<z.infer<typeof walletGetOneAdminAPISchema>, Wallet>;

export const walletGetAllAdminAPISchema = paginationSchema.extend({
  /** filter by wallet status */
  status: walletStatusSchema.optional(),
  /** filter by organization ID */
  orgId: objectIdSchema.optional(),
  /** filter by wallet holder type */
  holderType: WalletHolderTypeSchema.optional(),
  /** search query */
  search: z.string().optional(),
});
export type WalletGetAllAdminAPI = API<z.infer<typeof walletGetAllAdminAPISchema>, Wallet[]>;
